import API from '@/api'

export default {
  namespaced: true,
  state: {
    users: [],
    programs: [],
    crops: [],
    fields: [],
    pdfs: [],
    activeId: ''
  },
  mutations: {
    setActiveUser (state, id) {
      state.activeId = id;
    },
    setUsers (state, data) {
      state.users = data;
    },
    setPrograms (state, data) {
      state.programs = data;
    },
    setFields (state, data) {
      state.fields = data;
    },
    setCrops (state, data) {
      state.crops = data;
    },
    setPdfs (state, data) {
      state.pdfs = data;
    },
  },
  actions: {
    getUsers ({commit}) {
      return API.subAccounts.getUsers().then(res => {
        commit('setUsers', res.data)
      })
    },
    getPrograms ({commit, state}) {
      return API.subAccounts.getPrograms({subUserId: state.activeId}).then(res => {
        commit('setPrograms', res.data)
      })
    },
    getFields ({commit, state}) {
      return API.subAccounts.getFields(state.activeId).then(res => {
        commit('setFields', res.data.data)
      })
    },
    getCrops ({commit, state}) {
      return API.subAccounts.getCrops(state.activeId).then(res => {
        commit('setCrops', res.data)
      })
    },
    getPdfs ({commit, state}) {
      return API.subAccounts.getPdf({page: 0, take: 1000, subUserId: state.activeId}).then(res => {
        commit('setPdfs', res.data.pdfs)
      })
    },

    saveGeneral ({commit, state, getters}) {
      var user = getters['activeUser'];
      user.subUserId = state.activeId;

      return API.subAccounts.changeGeneral(user);
    },
    savePassword ({commit, state, getters}, pass) {
      return API.subAccounts.changePassword({newPassword: pass, subUserId: state.activeId});
    }
  },
  getters: {
    users (state) {
      return state.users;
    },
    programs (state) {
      return state.programs;
    },
    crops (state) {
      return state.crops;
    },
    fields (state) {
      return state.fields;
    },
    pdfs (state) {
      return state.pdfs;
    },
    activeUser (state) {
      return state.users.find(item => item.id == state.activeId);
    },
    programsCount (state) {
      return state.programs.length;
    }
  }
};;
